import axios from 'axios'
// import router from '../router/index.js'
// import Qs from 'qs'
// 
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, //'/apis'
  baseURL: 'https://www.zizhugroup1088.cn/api.php', //'/apis'
  // baseURL: 'http://zizhu.host01.ityunying.com/api.php', //'/apis'
  timeout: 60000
})

service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
service.interceptors.request.use(
  config => {
    // console.log(config);
    if (localStorage.getItem('id')) {
      config.headers['Authorization'] = "Bearer " + localStorage.getItem('id')
    }
    return config
  },
  error => {
    // console.log(error,'222');

    // console.log('request err:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res);
    return res
  },
  error => {
    // console.log(error.response, '1111');
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          localStorage.setItem('id', '');
          location.reload();
      }
    }
    // if(error.code)
    // console.log('response:', error)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js